import Navbar from "layout/navbar/Navbar";
import Banner from "./Banner";
import Footer from "shared/Footer";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProject } from "appState/project/projectSlice";
import { toast } from "react-toastify";

const SingleProject = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [project, setProject] = useState(null);

  const donateProp = state;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    dispatch(getProject({ projectId: id })).then((data) => {
      if (data?.payload?.status !== 200) {
        toast.error(`Unable to get project with id ${id}`);
        navigate("/projects");
        return;
      }
      setProject(data?.payload?.data?.project);
    });
  }, [dispatch, id, navigate]);

  return (
    <div className="bg-[#EEEEEE]">
      <Navbar />
      <Banner project={project} donateProp={donateProp} />
      <Footer />
    </div>
  );
};

export default SingleProject;
